// Design tokens for the agent module. Kept apart from AgentLayout so a card
// that only needs a colour does not have to import the whole shell (and with
// it the logo, the socket and the notification centre).

export const AGENT_SURFACE = "#F5F7FB";
export const AGENT_INK = "#0F172A";
export const AGENT_MUTED = "#64748B";
export const AGENT_LINE = "#E8EDF5";
export const AGENT_BRAND = "#0C237B";

// Attendance state colours, shared by the clock, the timeline and the charts
// so one state never reads as two different colours across the page.
export const WORK_GREEN = "#16A34A";
export const BREAK_AMBER = "#F59E0B";
export const OVER_RED = "#DC2626";

export const SIDEBAR_WIDTH = 248;
export const SIDEBAR_WIDTH_COLLAPSED = 76;

/** The standard white card the agent screens are built from. */
export const CARD_SX = {
  bgcolor: "#fff",
  borderRadius: "16px",
  border: `1px solid ${AGENT_LINE}`,
  p: 3,
};
